import { useMonarchRule } from '../../MonarchRulesProvider';
import { MultiCartTestData, UseMultiCartTestHookResult } from './types';

const CUSTOM_RULE_ID = 'multiCart';

const useMultiCart: UseMultiCartTestHookResult = () => {
  const { isLoading, value } = useMonarchRule<{
    data: MultiCartTestData;
  }>(CUSTOM_RULE_ID, {});

  if (isLoading || !value) {
    return {
      isLoading,
    };
  }

  const { data } = value;
  const variant = data?.enabled ? 'test' : 'control';

  return {
    isLoading,
    variant,
    data,
  };
};

export default useMultiCart;
